<template>
  <div>
    <v-data-table :items="items"
                  :headers="tableHeaders"
                  :options="paging"
                  @update:options="pagingUpdate"
                  :footer-props="{ itemsPerPageOptions: [paging.itemsPerPage] }"
                  :server-items-length="paging.accessibleItems">
      <template slot="item" slot-scope="props">
        <tr>
          <dynamic-value
            v-for="(header, i) in headers"
            tag-type="td"
            :data-type="header.fieldDataTypeCode.viewFieldDataTypeValue"
            :value="getNestedProperty(props.item, header.modelValue)"
            :key="i"
            :data-label="header.label"/>
          <td v-if="tab === 'docketEntries'" class="text-right">
            <v-btn v-if="hasAccess($PACONST.COMPONENT_DOCUMENTS_DOCKET_ENTRY, $PACONST.PERMISSION_TYPES.READ)
                   && props.item.hasDocuments"
                   text
                   icon
                   color="primary"
                   @click="readyDocumentPopup(props.item)">
              <v-icon>mdi-file</v-icon>
              <span class="sr-only">{{ $t('document.popup.iconSR') }}</span>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>

    <document-popup v-model="documentDialog" :parent-id="docketEntryID" category="docketentries"/>
  </div>
</template>

<script>
import PAUTIL from '@/support/utility';
import each from 'lodash/each';
import sortBy from 'lodash/sortBy';
import { mapGetters } from 'vuex';
import { getHeaderAlignment } from '@/support/ui';
import DocumentPopup from '@view/DocumentPopup';

export default {
  components: { DocumentPopup },
  props: {
    caseId: {
      type: String,
      required: true
    },
    tab: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      tableFields: [],
      items: [],
      documentDialog: false,
      docketEntryID: '',
      paging: new this.$cove.Pagination({
        itemsPerPage: 10
      })
    };
  },
  watch: {
    caseId () {
      this.updateTab();
    },
    tab () {
      this.updateTab();
    }
  },
  computed: {
    ...mapGetters('user', ['hasAccess']),
    tableHeaders () {
      let headers = [];
      let sorted = sortBy(this.tableFields.viewFields, 'orderBy');

      each(sorted, (header) => {
        headers.push({
          text: header.label,
          value: header.sortProperty,
          align: getHeaderAlignment(header.fieldDataTypeCode.viewFieldDataTypeValue)
        });
      });

      if (this.tab === 'docketEntries')
      {
        headers.push({
          text: this.$t('document.popup.iconSR'),
          sortable: false,
          align: 'end'
        });
      }

      return headers;
    },
    headers () {
      return sortBy(this.tableFields.viewFields, 'orderBy');
    }
  },
  mounted () {
    this.updateTab();
  },
  methods: {
    updateTab () {
      this.paging = new this.$cove.Pagination({
        itemsPerPage: 10
      });

      this.updateFieldsAjax().then((response) => {
        let data = response.data;
        this.tableFields = data;
        if (data.tableViewSorts !== undefined && data.tableViewSorts.length > 0)
        {
          let sorting = data.tableViewSorts[0];
          this.paging.sortBy = [sorting.sortProperty];
          this.paging.sortDesc = [sorting.sortDirection.sortDirectionID === this.$PACONST.SORT_DIRECTION_VALUE_DESC];
        }

        this.updateDataAjax().then((response2) => {
          this.items = Object.assign([], response2.data);
          this.paging.parseHeaders(response2);
        });
      });
    },
    updateData () {
      this.updateDataAjax().then((response) => {
        this.items = response.data;
        this.paging.parseHeaders(response);
      });
    },
    getNestedProperty (obj, property) {
      return PAUTIL.resolvePath(obj, property);
    },
    readyDocumentPopup (item) {
      this.docketEntryID = item.docketEntryID;
      this.documentDialog = true;
    },
    updateFieldsAjax () {
      let viewID = this.$PACONST.getTabByProperty('name', this.tab).viewID;
      let url = this.$cove.getAPI({ name: 'api.dynamicView.search', query: { caseID: this.caseId, viewID } });

      return this.$axios.get(url);
    },
    updateDataAjax () {
      let url = this.$cove.getAPI({
        name: 'api.cases.table',
        params: { caseID: this.caseId, searchType: this.tab.toLowerCase() }
      });

      return this.$axios.get(url, { headers: this.paging.generateHeaders() });
    },
    pagingUpdate (newPaging) {
      this.paging.update(newPaging, this.updateData);
    }
  }
};
</script>
